import { render, staticRenderFns } from "./DetalleAsignacionEquipoSubsedeDialogComponent.vue?vue&type=template&id=2eb49a17&scoped=true"
import script from "./DetalleAsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"
export * from "./DetalleAsignacionEquipoSubsedeDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./DetalleAsignacionEquipoSubsedeDialogComponent.vue?vue&type=style&index=0&id=2eb49a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb49a17",
  null
  
)

export default component.exports